module.exports = __webpack_public_path__ + "media/images/fbcalls/3-670f8e5893f0ccaa94f2a999da07394c.png";